export const AlternativeIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_13441_10993)">
        <path
          d="M9.91602 9.91797V11.3763C9.91602 11.7631 9.76237 12.134 9.48888 12.4075C9.21539 12.681 8.84446 12.8346 8.45768 12.8346H2.62435C2.23757 12.8346 1.86664 12.681 1.59315 12.4075C1.31966 12.134 1.16602 11.7631 1.16602 11.3763V5.54297C1.16602 5.15619 1.31966 4.78526 1.59315 4.51177C1.86664 4.23828 2.23757 4.08464 2.62435 4.08464H4.08268V2.6263C4.08268 2.23953 4.23633 1.8686 4.50982 1.5951C4.78331 1.32161 5.15424 1.16797 5.54102 1.16797H11.3743C11.7611 1.16797 12.1321 1.32161 12.4055 1.5951C12.679 1.8686 12.8327 2.23953 12.8327 2.6263V8.45964C12.8327 8.84641 12.679 9.21734 12.4055 9.49083C12.1321 9.76432 11.7611 9.91797 11.3743 9.91797H9.91602Z"
          stroke="#222530"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M5.54036 4.08594H4.08203V5.54427" stroke="#222530" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.08203 8.46094V9.91927H5.54036" stroke="#222530" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.45703 4.08594H9.91537V5.54427" stroke="#222530" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.91537 8.46094V9.91927H8.45703" stroke="#222530" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_13441_10993">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
